module.exports = __webpack_public_path__ + "img/check-square-fill.3d6013d4.svg";